/* ═══════════════════════════════════════════
   File Parser API client
   ═══════════════════════════════════════════ */

import { apiClient } from './client'
import type { FilePreviewResult } from '@/types'

export const fileParserApi = {
  preview: (file: File, config?: Record<string, unknown>) => {
    const formData = new FormData()
    formData.append('file', file)
    if (config) {
      formData.append('config', JSON.stringify(config))
    }
    return apiClient.post<{ success: boolean } & FilePreviewResult>(
      '/api/file-parser/preview',
      formData,
    )
  },
}
